import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'bulkLabelPrint.title',
    defaultMessage: 'Bulk Print Warning',
    id: 'UypWT/',
  },
  message: {
    description: 'bulkLabelPrint.message',
    defaultMessage: 'Some selected labels have already been printed. Reprint anyway?',
    id: 'ZWna2N',
  },
  cancel: {
    description: 'bulkLabelPrint.no',
    defaultMessage: "No, Don't Reprint",
    id: 'mIrsZ1',
  },
  yes: {
    description: 'printLabelPrintWarning.yes',
    defaultMessage: 'Yes, Reprint',
    id: 'zdLG/L',
  },
});
